import React from 'react';
import './PatientForms.scss';

const PatientForms: React.FC = () => {
  return (
    <div className="patient-forms-container">
      <div className="patient-forms-header">
        <h1>Patient Forms</h1>
        <p className="description">Download and fill out the necessary patient forms for your visit.</p>
      </div>

      <div className="patient-forms-content">
        <section className="forms-section">
          <h2>Patient Forms Download Links</h2>
          <ul className="forms-list">
            <li>
              <a href="/assets/forms/Notice-of-Privacy-Practices.pdf" target="_blank" rel="noopener">
                Notice of Privacy Policies
              </a>
            </li>
            <li>
              <a href="/assets/forms/NP-Intake-Form.pdf" target="_blank" rel="noopener">
                New Patient Intake Form
              </a>
            </li>
            <li>
              <a href="/assets/forms/Florida-First-Psychiatry-New-Patient-Packet.pdf" target="_blank" rel="noopener">
                New Patient Packet
              </a>
            </li>
            <li>
              <a href="/assets/forms/selfpay-insurance.pdf" target="_blank" rel="noopener">
                Self pay insurance form
              </a>
            </li>
            <li>
              <a href="/assets/forms/roi.pdf" target="_blank" rel="noopener">
                ROI
              </a>
            </li>
          </ul>
        </section>

        <section className="payment-section">
          <h3>All Major cards Are Accepted</h3>
          <div className="insurance-image-container">
            <img src="/assets/images/insurance1.jpg" alt="Accepted Insurance Cards" className="insurance-image" />
          </div>
          <a href="#" className="self-pay-link">Self Pay</a>
        </section>
      </div>
    </div>
  );
};

export default PatientForms;

